import {createActions} from 'client/framework';

const normalActions = [
  'GUIDE_TABLE_GUIDE_EXPANDED',
  'GUIDE_TABLE_GUIDE_MINIMIZED'
];

export default createActions(null, normalActions);
